import { useState } from "react";
import megaMenuData from "../data/megaMenuData";
import "../styles/navbar.css";
import { useNavigate, useLocation } from "react-router-dom";

import {
  HiOutlineCpuChip,
  HiOutlineCloud,
  HiOutlineChartPie,
  HiOutlinePresentationChartLine,
  HiOutlineSparkles,
  HiOutlineBeaker,
} from "react-icons/hi2";

import {
  HiOutlineAcademicCap,
  HiOutlineMap,
  HiOutlineUserGroup
} from "react-icons/hi2";

import {
  FiInfo,
  FiBookOpen,
  FiLayers,
  FiMail,
  FiMenu,
  FiX,
  FiEdit3,
  FiRepeat,
} from "react-icons/fi";

import logo from "../assets/logo.png";

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const categories = Object.keys(megaMenuData);

  /* ---------- STATES ---------- */
  const [activeCategory, setActiveCategory] = useState(categories[0]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [jobReadyOpen, setJobReadyOpen] = useState(false);
  const [supporterOpen, setSupporterOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileExploreOpen, setMobileExploreOpen] = useState(false);

  const handleNavigate = (path) => {
    setMobileOpen(false);
    setMobileExploreOpen(false);
    setJobReadyOpen(false);
    setSupporterOpen(false);
    navigate(path);
  };

  return (
    <nav className="navbar">
      {/* LOGO */}
      <div className="nav-logo" onClick={() => handleNavigate("/")}>
        <img src={logo} alt="Sprout Logo" className="sprout-logo-img" />
      </div>

      {/* HAMBURGER */}
      <div
        className="hamburger mobile-only"
        onClick={() => setMobileOpen(!mobileOpen)}
      >
        {mobileOpen ? <FiX /> : <FiMenu />}
      </div>

      {/* ================= DESKTOP ================= */}
      <div className="right-menu desktop-only">

        {/* EXPLORE */}
        <div
          className="explore-container"
          onMouseEnter={() => setMenuOpen(true)}
          onMouseLeave={() => setMenuOpen(false)}
        >
          {menuOpen && (
            <div className="udemy-menu">
              <div className="left-panel">
                {categories.map((cat, i) => (
                  <div
                    key={i}
                    className={`left-item ${
                      activeCategory === cat ? "active-left" : ""
                    }`}
                    onMouseEnter={() => setActiveCategory(cat)}
                  >
                    {cat}
                    <span className="arrow">›</span>
                  </div>
                ))}
              </div>

              <div className="right-panel">
                <h4 className="right-title">{activeCategory}</h4>
                {megaMenuData[activeCategory].map((item, i) => (
                  <p
                    key={i}
                    className="right-item"
                    onClick={() => handleNavigate("/syllabus")}
                  >
                    {item}
                    <span className="arrow">›</span>
                  </p>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* PROGRAMS */}
        <a onClick={() => navigate("/syllabus")}> Programs</a>

        {/* JOB READINESS */}
        <div
          className={`job-readiness-container ${
            jobReadyOpen ? "job-ready-active" : ""
          }`}
          onMouseEnter={() => setJobReadyOpen(true)}
          onMouseLeave={() => setJobReadyOpen(false)}
        >
          <span className="right-link">Job Readiness</span>

          {jobReadyOpen && (
            <div className="job-readiness-menu">

              <p onClick={() => navigate("/job-readiness/gen-ai-starter")}>
                <HiOutlineSparkles className="pro-icon" />
                Gen AI
              </p>

              <p onClick={() => navigate("/job-readiness/cloud-computing-starter")}>
                <HiOutlineCloud className="pro-icon" />
                Cloud Computing
              </p>

              <p onClick={() => navigate("/job-readiness/data-analysis-starter")}>
                <HiOutlineChartPie className="pro-icon" />
                Data Analytics
              </p>

              {/* NEW COURSES ADDED */}

              <p onClick={() => navigate("/job-readiness/power-bi-data-analyst")}>
                <HiOutlinePresentationChartLine className="pro-icon" />
                Power BI Data Analyst
              </p>

              <p onClick={() => navigate("/job-readiness/ai-engineer")}>
                <HiOutlineCpuChip className="pro-icon" />
                AI Engineer
              </p>

              <p onClick={() => navigate("/job-readiness/agentic-ai-career-track")}>
                <HiOutlineBeaker className="pro-icon" />
                Agentic AI Career Track
              </p>

            </div>
          )}
        </div>

        {/* SUPPORTER */}
        <div
          className="supporter-container"
          onMouseEnter={() => setSupporterOpen(true)}
          onMouseLeave={() => setSupporterOpen(false)}
        >
          <span className="right-link">Supporter</span>

          {supporterOpen && (
            <div className="supporter-menu open">
              <p onClick={() => navigate("/placement-guidance")}>
                <HiOutlineAcademicCap className="pro-icon" />
                Placement Training
              </p>

              <p onClick={() => navigate("/career-guidance")}>
                <HiOutlineMap className="pro-icon" />
                Career Guidance
              </p>

              <p onClick={() => navigate("/hire-talent")}>
                <HiOutlineUserGroup className="pro-icon" />
                Hire Talent
              </p>
            </div>
          )}
        </div>

        <a onClick={() => navigate("/blogs")}> Blog</a>
        <a onClick={() => navigate("/case-studies")}> Case Studies</a>
        <a onClick={() => navigate("/methodology")}> Methodology</a>
        <a onClick={() => navigate("/about")}> About</a>

        <button
          className={`contact-btn ${isActive("/contact") ? "active" : ""}`}
          onClick={() => navigate("/contact")}
        >
          Contact Us
        </button>
      </div>

      {/* ================= MOBILE ================= */}
      {mobileOpen && (
        <div className="mobile-menu mobile-only">

          <p onClick={() => handleNavigate("/syllabus")}>Programs</p>

          <p
            className="mobile-parent"
            onClick={() => setJobReadyOpen(!jobReadyOpen)}
          >
            Job Readiness ▾
          </p>

          {jobReadyOpen && (
            <div className="mobile-submenu">

              <span onClick={() => handleNavigate("/job-readiness/gen-ai-starter")}>
                Gen AI
              </span>

              <span onClick={() => handleNavigate("/job-readiness/cloud-computing-starter")}>
                Cloud Computing
              </span>

              <span onClick={() => handleNavigate("/job-readiness/data-analysis-starter")}>
                Data Analytics
              </span>

              <span onClick={() => handleNavigate("/job-readiness/power-bi-data-analyst")}>
                Power BI Data Analyst
              </span>

              <span onClick={() => handleNavigate("/job-readiness/ai-engineer")}>
                AI Engineer
              </span>

              <span onClick={() => handleNavigate("/job-readiness/agentic-ai-career-track")}>
                Agentic AI Career Track
              </span>

            </div>
          )}

          <p
            className="mobile-parent"
            onClick={() => setSupporterOpen(!supporterOpen)}
          >
            Supporter ▾
          </p>

          {supporterOpen && (
            <div className="mobile-submenu">
              <span onClick={() => handleNavigate("/placement-guidance")}>
                Placement Training
              </span>
              <span onClick={() => handleNavigate("/career-guidance")}>
                Career Guidance
              </span>
              <span onClick={() => handleNavigate("/hire-talent")}>
                Hire Talent
              </span>
            </div>
          )}

          <p onClick={() => handleNavigate("/blogs")}>Blog</p>
          <p onClick={() => handleNavigate("/case-studies")}>Case Studies</p>
          <p onClick={() => handleNavigate("/methodology")}>Methodology</p>
          <p onClick={() => handleNavigate("/about")}>About</p>

          <button
            className={`contact-btn mobile ${isActive("/contact") ? "active" : ""}`}
            onClick={() => handleNavigate("/contact")}
          >
            Contact Us
          </button>

        </div>
      )}
    </nav>
  );
}